
import Vue from 'vue';
import config from '@/config/config.json'
import vhero from '@/components/shared/VHero.vue';
import { mapState } from 'vuex';
import { getDeviceUuid } from "../services/deviceUuid.js"

export default Vue.extend({
  data() {
    return {
      titulo: 'Inicio',
      config: config // Utiliza el contenido del archivo JSON como datos del componente
    };
  },
  components: {
    vhero,
  },
  computed: {
    ...mapState(['jwt']),
  },
  });
